/* mixins/user */
import { mapActions, mapGetters } from 'vuex'

import { Role } from '@/utility/constants'

export default {
    created() {
        // Map roles to vue instance so they can be used in html
        Object.entries(Role).forEach(([key, value]) => {
            this[key] = value
        })
    },

    computed: {
        ...mapGetters([
            'getDisplayName',
            'getUserId',
            'getUserRoles'
        ]),
    },

    methods: {
        ...mapActions([
            'setUser'
        ]),

        hasUserRole(roles) {
            if (!Array.isArray(roles)) {
                return this.getUserRoles.includes(roles)
            }

            return roles.some(r => this.getUserRoles.includes(r))
        }
    }
}